<script lang="ts">
    import FieldHeading from './field-heading.svelte'
    import Odontograma from '../../odontograma/Odontograma.svelte'
    import { createDefaultOdontogramaValue, type OdontogramaValue } from '../../odontograma/odontograma-data'

    export let label: string
    export let data: Record<string, any>
    export let value: OdontogramaValue = createDefaultOdontogramaValue()
    export let required = false
    export let readOnly = false

    const stages = [
        { label: 'Pendente', color: '#FF9800' },
        { label: 'Concluído', color: '#4CAF50' },
        { label: 'Não tratar', color: '#607D8B' },
    ]
</script>

<div class="view-field">
    <FieldHeading {label} {required} {readOnly} />
    <Odontograma {stages} bind:value {readOnly} />
</div>

<style>
    .view-field {
        display: flex;
        flex-direction: column;
        width: 100%;
    }
</style>
